<div class="login-container">
    <!-- Decorative background elements -->
    <div class="bg-decoration">
        <div class="bg-orb bg-orb-1"></div>
        <div class="bg-orb bg-orb-2"></div>
        <div class="bg-orb bg-orb-3"></div>
    </div>

    <div class="login-card glass-panel">
        <!-- Logo & Branding -->
        <div class="header">
            <div class="logo-mark">
                <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="40" height="40" rx="10" fill="url(#logo-gradient)" />
                    <path d="M12 20L18 14L24 20L18 26L12 20Z" fill="white" opacity="0.9" />
                    <path d="M18 14L24 20L30 14L24 8L18 14Z" fill="white" opacity="0.7" />
                    <path d="M18 26L24 20L30 26L24 32L18 26Z" fill="white" opacity="0.5" />
                    <defs>
                        <linearGradient id="logo-gradient" x1="0" y1="0" x2="40" y2="40">
                            <stop stop-color="hsl(250, 80%, 60%)" />
                            <stop offset="1" stop-color="hsl(180, 100%, 35%)" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <h1 class="text-gradient">WorkGraph</h1>
            <p class="tagline">Create your account to get started</p>
        </div>

        <!-- Error banner -->
        @if (error()) {
            <div class="error-banner" (click)="clearError()">
                <span class="error-icon">⚠</span>
                <span>{{ error() }}</span>
                <button class="error-dismiss" aria-label="Dismiss">✕</button>
            </div>
        }

        <!-- OAuth Providers -->
        <div class="auth-providers">
            <button
                class="provider-btn"
                (click)="signupWithGoogle()"
                [disabled]="loading()"
                id="signup-google-btn"
            >
                <svg class="provider-icon" viewBox="0 0 24 24" width="20" height="20">
                    <path
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
                        fill="#4285F4"
                    />
                    <path
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        fill="#34A853"
                    />
                    <path
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 001 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z"
                        fill="#FBBC05"
                    />
                    <path
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        fill="#EA4335"
                    />
                </svg>
                <span>Sign up with Google</span>
            </button>
        </div>

        <div class="divider">
            <span>or continue with email</span>
        </div>

        <!-- Email/Password Signup Form -->
        <form class="signup-form" (ngSubmit)="onSubmit()" #signupForm="ngForm">
            <div class="form-group">
                <label for="name">Full Name</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    [(ngModel)]="formData.name"
                    placeholder="John Doe"
                    required
                    [disabled]="loading()"
                />
            </div>
            <div class="form-group">
                <label for="email">Email address</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    [(ngModel)]="formData.email"
                    placeholder="name@company.com"
                    required
                    email
                    [disabled]="loading()"
                />
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input
                    type="password"
                    id="password"
                    name="password"
                    [(ngModel)]="formData.password"
                    placeholder="Create a password"
                    required
                    minlength="8"
                    [disabled]="loading()"
                />
                <small class="password-hint"
                    >At least 8 characters with uppercase, lowercase, number, and symbol</small
                >
            </div>
            <div class="form-group">
                <label for="confirm-password">Confirm Password</label>
                <input
                    type="password"
                    id="confirm-password"
                    name="confirmPassword"
                    [(ngModel)]="formData.confirmPassword"
                    placeholder="Confirm your password"
                    required
                    [disabled]="loading()"
                />
            </div>
            <button type="submit" class="btn btn-primary full-width" [disabled]="loading()">
                {{ loading() ? 'Creating Account...' : 'Create Account' }}
            </button>
        </form>

        <!-- Loading overlay -->
        @if (loading()) {
            <div class="loading-overlay">
                <div class="spinner"></div>
                <p>Creating your account...</p>
            </div>
        }

        <!-- Footer -->
        <div class="footer">
            <p>
                Already have an account?
                <a routerLink="/login">Sign in</a>
            </p>
            <p class="legal">
                By continuing, you agree to our
                <a href="#">Terms of Service</a> and
                <a href="#">Privacy Policy</a>
            </p>
        </div>
    </div>
</div>
